const downloadAsCSV = (data: any[], filename: string) => {
  if (data.length === 0) return;

  // Get headers from the first object's keys
  const headers = Object.keys(data[0]);

  // Create CSV string with headers
  const csvContent = [
    // Add headers row
    headers.join(','),
    // Add data rows
    ...data.map((row) => {
      return headers
        .map((header) => {
          const value = row[header];
          const stringValue = String(value);
          // Handle values that need quotes (contain commas, quotes, or newlines)
          if (
            stringValue.includes(',') ||
            stringValue.includes('"') ||
            stringValue.includes('\n')
          ) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        })
        .join(',');
    }),
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { downloadAsCSV };
